import { useEffect, useId, useLayoutEffect, useState } from "react";
import { useT } from "@/i18n/I18nProvider";
import {
  THEMES,
  applyThemePreference,
  readThemePreference,
  watchThemePreference,
  writeThemePreference,
  type ThemePreference,
} from "./theme-preference";

const LABELS: Record<ThemePreference, string> = {
  system: "nav.theme.system",
  light: "nav.theme.light",
  dark: "nav.theme.dark",
};

export function ThemeSelector() {
  const { t } = useT("nav");
  const id = useId();
  const [theme, setTheme] = useState<ThemePreference>(() => readThemePreference());

  /* 프로덕션은 파싱 차단 bootstrap에서 이미 값을 적용합니다. 이 layout effect는 개발·테스트용
     보완이며 어떤 소비자도 다시 마운트하거나 포커스하지 않습니다. */
  useLayoutEffect(() => applyThemePreference(theme), [theme]);
  useEffect(() => watchThemePreference(setTheme), []);

  return (
    <span className="theme-select">
      <label className="visually-hidden" htmlFor={id}>{t("nav.theme.label")}</label>
      <select
        id={id}
        className="theme-select__control"
        data-testid="theme-select"
        value={theme}
        onChange={(event) => {
          const next = event.currentTarget.value as ThemePreference;
          if (!THEMES.includes(next) || next === theme) return;
          applyThemePreference(next);
          setTheme(next);
          writeThemePreference(next);
        }}
      >
        {THEMES.map((value) => <option key={value} value={value}>{t(LABELS[value])}</option>)}
      </select>
    </span>
  );
}
